<template>
  <box class="bq-box-contact" title="联系我们">
    <card
      class="bq-box-map"
      :layout="!isMobile ? 'horizontal' : 'vertical'"
      size="map"
      :cover="aboutData.map"
    >
      <div class="bq-box-map-detail" slot="content">
        <p v-if="!isMobile">联系电话：{{ aboutData.info.tel }}</p>
        <p v-else>
          联系电话：
          <a :href="`tel:+${aboutData.info.tel}`">
            {{ aboutData.info.tel }}
          </a>
        </p>

        <p>公司地址：{{ aboutData.info.address }}</p>
      </div>
    </card>
  </box>
</template>

<script>
import Box from '@/components/Box';
import Card from '@/components/Card';

import { aboutData } from '../About/about.js';
import { isWirelessDevice } from '../../../utils/utils.js';

export default {
  name: 'contact',

  components: {
    Box,
    Card,
  },

  data() {
    return {
      isMobile: false,
      aboutData,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
